var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('notifications'),_vm._v(" "),_c('div',{staticClass:"row trebuchet tabs-border-bottom-none"},[_c('div',{staticClass:"col-md-12"},[_c('edit-profile',{attrs:{"userId":_vm.juniorId}})],1)])]],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31e0d9f4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./src/components/user/dashboard/pages/junior/junior-registration/junior-registration.html
// module id = null
// module chunks = 